import axios, { AxiosResponse } from 'axios';
import axiosInstance from '@/config/apiConfig';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import {
  IApiResponse,
  IFetchCronJobsTrackerData,
} from './cronJobsTracker.types';

export const fetchCronJobsTrackerData = ({
  page,
  limit,
  cronJobId,
  requestId,
  jobName,
  startDate,
  endDate,
  order,
  orderBy,
  status,
}: IFetchCronJobsTrackerData): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInstance({
    url: API_URL_CONFIG.CRON_JOBS_TRACKER.GET_CRON_JOBS_TRACKER,
    // url:"http://localhost:3030/vdi2/cronjobs/tracker",
    params: {
      page,
      limit,
      ...(cronJobId ? { cronJobId } : {}),
      ...(requestId ? { requestId } : {}),
      ...(jobName ? { jobName } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(status ? { status } : {}),
    },
  });
};
